import { ColumnDef } from '@tanstack/react-table';
import { SortableHeader, TruncatedCell } from '@/components';
import { formatDisplayDate } from '@/utils/date';
import { MedicationAllDataRecord } from '../types';

const buildPrescriberName = (
  record: MedicationAllDataRecord,
): string | undefined => {
  const parts = [
    record.practitioner?.givenName,
    record.practitioner?.familyName,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : undefined;
};

export const createFullMedicationsColumns =
  (): ColumnDef<MedicationAllDataRecord>[] => [
    {
      accessorKey: 'name',
      header: 'Medication',
      cell: ({ row }) =>
        row.original.name ? (
          <TruncatedCell text={row.original.name} className="font-medium" />
        ) : (
          'No data available'
        ),
    },
    {
      id: 'prescriber',
      header: 'Prescriber',
      cell: ({ row }) =>
        buildPrescriberName(row.original) || 'No data available',
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row }) => row.original.status || 'No data available',
    },
    {
      accessorKey: 'dosage',
      header: 'Dosage',
      cell: ({ row }) => row.original.dosage || 'No data available',
    },
    {
      accessorKey: 'doseRoute',
      header: 'Route',
      cell: ({ row }) => row.original.doseRoute || 'No data available',
    },
    {
      accessorKey: 'startDatetime',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>Start</SortableHeader>
      ),
      cell: ({ row }) =>
        formatDisplayDate(row.original.startDatetime) || 'No data available',
    },
    {
      accessorKey: 'endDatetime',
      enableSorting: true,
      header: ({ column }) => (
        <SortableHeader column={column}>End</SortableHeader>
      ),
      cell: ({ row }) =>
        formatDisplayDate(row.original.endDatetime) || 'No data available',
    },
    {
      accessorKey: 'patientInstructions',
      header: 'Instructions',
      cell: ({ row }) =>
        row.original.patientInstructions || 'No data available',
    },
  ];
